namespace Nobox.Administration {


    import fld = UserRow.Fields;
    @Serenity.Decorators.registerEditor('Nobox.Administration.TenantMemberEditor')
    export class TenantMemberEditor extends Serenity.Extensions.GridEditorBase<UserRow> {
        protected getColumnsKey() { return TenantMemberColumns.columnsKey; }
        protected getDialogType() { return TeamDetailDialog; }
        protected getIdProperty() { return UserRow.idProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }

        private pendingChanges: Q.Dictionary<any> = {};
        public callbackSave: () => void;
        public items: UserRow[];
        public maxuser: number;
        public membership: string;

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
        }

        protected getButtons() {
            var buttons = [];
            buttons.push({
                title: 'Save Changes',
                cssClass: 'apply-changes-button disabled',
                onClick: e => {
                    if (Object.keys(this.pendingChanges).length === 0) {
                        return;
                    }

                    // this calls save service for all modified rows, one by one
                    // you could write a batch update service
                    var keys = Object.keys(this.pendingChanges);
                    var current = -1;
                    var self = this;
                    (function saveNext() {
                        if (++current >= keys.length) {
                            self.refresh();
                            return;
                        }

                        var key = keys[current];
                        var entity = Q.deepClone(self.pendingChanges[key]);
                        entity.Id = key;

                        Q.serviceRequest(UserService.Methods.Update, {
                            EntityId: key,
                            Entity: entity
                        }, (response) => {
                            delete self.pendingChanges[key];
                            saveNext();
                        });
                    })();
                },
                separator: true
            });
            buttons.push({
                title: "",
                cssClass: 'count-button',
                onClick: e => {
                },
                separator: true
            });
            return buttons;
        }

        public updateButton() {
            this.element.find(".count-button").text(`${this.membership} : ${this.items.length} of ${this.maxuser == null ? "unlimited" : this.maxuser} members`)
        }

        private selectFormatter(ctx: Slick.FormatterContext, idField: string, lookup: any) {
            if ((ctx.item as Slick.NonDataRow).__nonDataRow)
                return Q.htmlEncode(ctx.value);
            if (ctx.item.Owner == 1)
                return Q.htmlEncode("Owner");
            if (ctx.item.IsAdmin == 1)
                return Q.htmlEncode("Owner");
            if (Q.Authorization.hasPermission("Nobox:Manager")) {
                if (ctx.item.IsAdmin == 2) {
                    return Q.htmlEncode("Manager")
                }
            };
            if (Q.Authorization.hasPermission("Nobox:Member")) {
                return "";
            };
            if (ctx.item.Owner == Q.Authorization.username) {
                if (ctx.item.Owner == 1)
                    return Q.htmlEncode("Owner");
                if (ctx.item.IsAdmin == 1)
                    return Q.htmlEncode("Owner");
                if (Q.Authorization.hasPermission("Nobox:Manager")) {
                    if (ctx.item.IsAdmin == 2) {
                        return Q.htmlEncode("Manager")
                    }
                };
                if (Q.Authorization.hasPermission("Nobox:Member")) {
                    return "";
                };
                return "";
            }
            var klass = 'edit';
            var item = ctx.item as UserRow;
            var pending = this.pendingChanges[item.UserId];
            var column = ctx.column as Slick.Column;

            if (pending && pending[idField] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, idField);
            var markup = "<select class='" + klass +
                "' data-field='" + idField +
                "' style='width: 100%; max-width: 100%'>";
            for (var c of lookup) {
                let id = c.id;
                markup += "<option value='" + Q.attrEncode(id) + "'";
                if (id == value) {
                    markup += " selected";
                }
                markup += ">" + Q.htmlEncode(c.text) + "</option>";
            }
            return markup + "</select>";
        }


        private getEffectiveValue(item, field): any {
            var pending = this.pendingChanges[item.TnId];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }

            return item[field];
        }

        protected getColumns() {
            var columns = super.getColumns();

            //var category = Q.first(columns, x => x.field === fld.IsAdmin);
            //category.referencedFields = [fld.IsAdmin];
            //category.format = (ctx) => {
            //    return this.selectFormatter(ctx, fld.IsAdmin, [{ id: 2, text: "Manager" }, { id: 3, text: "Member" }])
            //};
            var roleLookup = RoleRow.getLookup().itemById;
            Q.first(columns, x => x.field == fld.RoleIds).format =
                ctx => {
                    let value = ctx.value;
                    if (!value)
                        return "";

                    var splitValue = ctx.value.split(",") as string[];
                    var finalValue = "";
                    splitValue.forEach((x, i) => {
                        if (i == 0) {
                            finalValue = roleLookup[x].RoleName;
                        } else {
                            finalValue += ", " + roleLookup[x].RoleName;
                        }
                    });
                    return finalValue;
                };

            //columns.splice(1, 0, {
            //    field: 'Remove User',
            //    name: '',
            //    format: (ctx) => {
            //        var item = ctx.item as UserRow;
            //        if (Q.Authorization.hasPermission("Nobox:Owner")) {
            //            if (item.IsAdmin == 2) {
            //                return `<a class="inline-action remove-user" title="Remove User from this company">
            //            <i class="fa fa-trash-o text-red"></i></a>`;
            //            } else if (item.IsAdmin == 3) {
            //                return `<a class="inline-action remove-user" title="Remove User from this company">
            //            <i class="fa fa-trash-o text-red"></i></a>`;
            //            } else {
            //                return "";
            //            }
            //        } else {
            //            if (Q.Authorization.hasPermission("Nobox:Member")) {
            //                return "";
            //            }
            //            else if (Q.Authorization.hasPermission("Nobox:Manager")) {
            //                if (item.IsAdmin == 3) {
            //                    return `<a class="inline-action remove-user" title="Remove User from this company">
            //            <i class="fa fa-trash-o text-red"></i></a>`;
            //                } else {
            //                    return "";
            //                }
            //            }
            //        }
            //    },
            //    width: 24,
            //    minWidth: 24,
            //    maxWidth: 24
            //});
            columns.splice(0, 0, {
                field: 'Remove User',
                name: '',
                format: (ctx) => {
                    var item = ctx.item as UserRow;
                    if (item.RoleIds == "1" || item.RoleIds.search("1,")!=-1) {
                        return "";
                    }
                    if (item.Username == Q.Authorization.username) {
                        return "";
                    }
                    if (Q.Authorization.hasPermission("Role:Owner") || Q.Authorization.hasPermission("Role:Manager")) {
                        return `<a class="inline-action remove-user" title="Remove User from this tenant">
                        <i class="fa fa-trash-o text-red"></i></a>`;
                    }
                },
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            columns.push({
                field: 'Edit Roles',
                name: '',
                format: (ctx) => {
                    if (Q.Authorization.hasPermission("Role:Owner") || Q.Authorization.hasPermission("Role:Manager")) {
                        return `<a class="inline-action role-user" title="Edit Roles">
                        <i class="fa fa-users text-blue"></i></a>`;
                    } else {
                        return "";
                    }
                },
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            return columns;
        }

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var pending = this.pendingChanges[item.TenantId];

            var effective = this.getEffectiveValue(item, field);
            var oldText: string;
            if (input.hasClass("numeric"))
                oldText = Q.formatNumber(effective, '0.##');
            else
                oldText = effective as string;

            var value;
            if (field === 'UnitPrice') {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass("numeric")) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else
                value = text;

            if (!pending) {
                this.pendingChanges[item.TenantId] = pending = {};
            }

            pending[field] = value;
            item[field] = value;
            this.view.refresh();

            if (input.hasClass("numeric"))
                value = Q.formatNumber(value, '0.##');

            input.val(value).addClass('dirty');

            this.setSaveButtonState();
        }
        private setSaveButtonState() {
            this.toolbar.findButton('apply-changes-button').toggleClass('disabled',
                Object.keys(this.pendingChanges).length === 0);
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;
            var $this = this;
            var item = this.itemAt(row);
            var target = $(e.target);


            // if user clicks "i" element, e.g. icon

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('role-user')) {
                    var dlg = new UserRoleDialog({
                        tenantID: item.TenantId,
                        userID: item.UserId,
                        username: item.Username
                    });
                    dlg.dialogOpen();
                    dlg.element.on('dialogclose', () => {
                        UserService.List({}, (res) => {
                            $this.setItems(res.Entities);
                        });
                    });
                }

                if (target.hasClass('remove-user')) {
                    Q.confirm('Remove ' + item.Username + ' from this tenant?', () => {
                        UserService.Delete({
                            EntityId: item.UserId,
                        }, response => {
                            this.callbackSave()
                        });
                    });
                }
            }
        }
    }
}